import Submenu from './Submenu'

export default Submenu
